import { render, staticRenderFns } from "./yi_curd_expand_button.vue?vue&type=template&id=06b5ec0f&scoped=true&"
import script from "./yi_curd_expand_button.vue?vue&type=script&lang=js&"
export * from "./yi_curd_expand_button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b5ec0f",
  null
  
)

export default component.exports